
export default function rentEquipment() {


    const rentEquipmentBtn = document.querySelector('.js-rent-equipment');
    const rentEquipmentGoods = document.querySelectorAll('.car-page__aside-good');
    var distance = 0;


    if( rentEquipmentBtn ) {
        rentEquipmentBtn.addEventListener('click',function(){
            for (let el of rentEquipmentGoods) {
                el.classList.toggle("car-page__aside-good_show");
            }
            if ( rentEquipmentBtn.innerText == "See more" ) {
                rentEquipmentBtn.innerText = "See less";
            } else {
                rentEquipmentBtn.innerText = "See more";
            }

            setTimeout(() => {
                distance = document.querySelector('#car-equipment-archon').offsetTop;

                window.scrollTo({
                    top: distance,
                    left: 0,
                    behavior: 'smooth'
                });
            }, 50);
        });
    }


}